import { createEvent, createStore, restore } from 'effector'
import { fx } from 'src/libs'
import { rolesObj } from 'src/libs/role'
import { Team } from 'src/pages/budget/budgetTeams/types'
import { CEO_NAME_TEAM } from 'src/pages/budget/const'
import {
  AddArticleItemPayload,
  ArticleType,
  ModalArticleItem,
  ResponseArticleItem,
} from 'src/pages/budget/types'

export type ApiListResponse<T> = {
  items: T[]
  total: number
}

export type User = {
  email: string
  firstName: string
  id: string
  lastName: string
  timezone: string
  username: string
  roles: string[]
  deletedAt: string | null
}

export type UsersState = {
  allUsersMap: Map<string, string>
  adminsMap: Map<string, string>
  allUserBudgetMap: Map<string, string>
}

export type UserResponse = ApiListResponse<User>
export type TeamsResponse = ApiListResponse<Team>

export const openModalArticleItem = createEvent<ModalArticleItem>()
export const closeModalArticleItem = createEvent()


export const getTeamListFx = fx<void, TeamsResponse>({
  method: 'GET',
  url: '/budget/team',
})

export const getUsersFx = fx<void, UserResponse>({
  method: 'GET',
  url: '/user?populate=["User", "User.roles"]',
})

export const getArticleListFx = fx<void, { items: ArticleType[] }>({
  method: 'GET',
  url: '/budget/article',
})

export const addArticleItemFx = fx<AddArticleItemPayload, ResponseArticleItem>({
  method: 'POST',
  url: '/budget/article_item',
})

export const $users = restore<UsersState>(
  getUsersFx.doneData.map(({ body }) => {
    const allUsersMap = new Map<string, string>()
    const adminsMap = new Map<string, string>()
    const allUserBudgetMap = new Map<string, string>()

    body.items.forEach((user) => {
      const fullName = `${user.firstName} ${user.lastName}`

      allUsersMap.set(user.id, fullName)

      if (user.roles.includes(rolesObj.admin)) {
        adminsMap.set(user.id, fullName)
      }
      if (user.roles.includes(rolesObj.budget)) {
        allUserBudgetMap.set(user.id, fullName)
      }
    })

    return {
      allUsersMap,
      adminsMap,
      allUserBudgetMap,
    }
  }),
  {
    allUsersMap: new Map(),
    adminsMap: new Map(),
    allUserBudgetMap: new Map(),
  },
)

export const $ceoTeam = createStore<{ ceoTeam: string[] }>({
  ceoTeam: [],
}).on(getTeamListFx.doneData, (_, res) => {
  const ceoTeam = Array.from(
    new Set(
      res.body.items
        .filter(
          ({ parentTeamId, name }) =>
            !parentTeamId && name.toUpperCase() === CEO_NAME_TEAM,
        )
        .flatMap(({ permissions }) => [
          ...permissions.submit,
          ...permissions.approve,
          ...permissions.pay,
        ]),
    ),
  )

  return { ceoTeam }
})


export const $allUserApprove = createStore<{ allUserApprove: string[] }>({
  allUserApprove: [],
}).on(getTeamListFx.doneData, (_, res) => {
  const allUserApprove = Array.from(
    new Set(
      res.body.items.flatMap(({ permissions }) => [...permissions.approve]),
    ),
  )

  return { allUserApprove }
})

export const $modalArticleItem = createStore<ModalArticleItem | null>(null)
  .on(openModalArticleItem, (_, payload) => payload)
  .reset(closeModalArticleItem)

